import React, { FunctionComponent, useState } from 'react';
import {
  View,
  Text,
  Divider,
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
} from '@upstox/upstox-ui';
import * as css from './IPOTimeline.style';

type Props = {
  label?: string;
  value?: React.ReactNode;
  status?: boolean;
  isSeoApp?: boolean;
};

const IPOTimeLineItem: FunctionComponent<Props> = ({
  label,
  value,
  status = false,
  isSeoApp = false,
}) => {
  return (
    <View flexDirection="column">
      <View
        justifyContent="space-between"
        alignItems="center"
        css={css.timelineItem}
      >
        {isSeoApp ? (
          <View flexDirection="column">
            <View css={css.timelineItemHeader}>
              {status ? (
                <Text variant="bodyBold" size="m">
                  {label}
                </Text>
              ) : (
                <Text variant="heading3" color="text.2" weight="bold">
                  {label}
                </Text>
              )}
            </View>
            <View>
              {status ? (
                <Text variant="bodyBold" size="m">
                  {value}
                </Text>
              ) : (
                <Text variant="meta" size="m">
                  {' '}
                  {value}
                </Text>
              )}
            </View>
          </View>
        ) : (
          <>
            <View alignItems="center">
              <View css={css.statusIcon}>
                {status ? (
                  <CheckboxCheckedIcon size="small" color="data.positive" />
                ) : (
                  <CheckboxUncheckedIcon size="small" color="ui3" />
                )}
              </View>
              <View>
                {status ? (
                  <Text variant="bodyBold">{label}</Text>
                ) : (
                  <Text variant="heading3" color="text.2">
                    {label}
                  </Text>
                )}
              </View>
            </View>
            <View>
              {status ? (
                <Text color="text.1" variant="meta">
                  {value}
                </Text>
              ) : (
                <Text variant="meta"> {value}</Text>
              )}
            </View>
          </>
        )}
      </View>
    </View>
  );
};

export default IPOTimeLineItem;
